let _settings;

/* global document, Office */
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    document.getElementById("sideload-msg").style.display = "none";
    //document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = run;
    document.getElementById("companycode-submit").onclick = submitCompanyCode;
    document.getElementById("closeDialogBtn").onclick = closeDialog;

    _settings = Office.context.roamingSettings;

    readCurrentMail();
  }
  init();
});

var token = "";
var mailContent = "";

export async function init() {
  var promptCompanyKey = false;

  var userToken = "";
  try {
    const auth = OfficeRuntime.auth;
    userToken = await auth.getAccessToken();
  } catch (_) {
    //try get companyCode
    var companyCode = _settings.get("company-code");
    if (companyCode) {
      loginWithCompanyCode(companyCode);
    } else {
      promptCompanyKey = true;
    }
  }

  //get token
  if (promptCompanyKey) {
    //show
    document.getElementById("companyCode").style.display = "block";
  } else {
    try {
      const response = await fetch("https://api.arkasoftware.dk/api/TokenByMicrosoft365",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + userToken
          },
        });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      //console.log("Server response:", result);

      token = result.token;

      getAll();
    } catch (error) {
      console.log("[TokenByMicrosoft365] Error sending data:", error.message);
      return;
    }
  }

  /*   let testprofile2 =
      JSON.stringify
        ({
          "api_key": "42369bc2-a1a9-43d2-b41d-9699974cc620",
          "password": "ArkaMobilTest"
        });
    
    try {
      const response = await fetch("https://api.arkasoftware.dk/api/Token",
        {
          method: "POST",
          body: testprofile2,
          headers: {
            "Content-type": "application/json",
          },
        });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const result = await response.json();
      //console.log("Server response:", result);
  
      token = result.token;
    } catch (error) {
      console.log("[Token] Error sending data:", error.message);
      return;
    } */
}

function submitCompanyCode() {
  const codeinput = document.getElementById("companycodeinput");
  if (codeinput != null) {
    loginWithCompanyCode(codeinput.value);
  }
}

async function loginWithCompanyCode(companyCode) {
  try {
    const response = await fetch("https://api.arkasoftware.dk/api/TokenByCode",
      {
        method: "POST",
        body: JSON.stringify
          ({
            "companyCode": companyCode,
          }),
        headers: {
          "Content-type": "application/json",
        },
      });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    //console.log("Server response:", result);

    token = result.token;

    //hide
    document.getElementById("companyCode").style.display = "none";

    //save
    _settings.set("company-code", companyCode);
    _settings.saveAsync(saveMyAddInSettingsCallback);

    getAll();
  } catch (error) {
    console.log("[TokenByCode] Error sending data:", error.message);
    return;
  }
}

// Callback function after saving custom roaming settings.
function saveMyAddInSettingsCallback(asyncResult) {
  if (asyncResult.status === Office.AsyncResultStatus.Failed) {
    // Handle the failure.
  }
}

async function getAll() {
  //show
  document.getElementById("app-body").style.display = "flex";

  initializeCustomerSearch();

  //get responsible
  let result = await MakeRequest("EmployeeList/All");
  if (result != null) {
    var responsibleselect = document.getElementById("responsible");
    if (responsibleselect != null) {
      result.forEach(c => {
        responsibleselect.innerHTML += "<option value=\"" + c.id + '\x07' + c.employee.employeeNo + "\">" + c.employee.firstName + "</option>"
      });
    }
  }

  //get hourtypes
  result = await MakeRequest("TimeEntryTypeList/All");
  if (result != null) {
    var hourtypeselect = document.getElementById("hourtype");
    if (hourtypeselect != null) {
      result.forEach(c => {
        hourtypeselect.innerHTML += "<option value=\"" + c.id + '\x07' + c.timeEntryType.typeNo + "\">" + c.timeEntryType.name + "</option>"
      });
    }
  }

  //get types
  result = await MakeRequest("JobTypeList/All");
  if (result != null) {
    var typeselect = document.getElementById("type");
    if (typeselect != null) {
      result.forEach(c => {
        typeselect.innerHTML += "<option value=\"" + c.id + '\x07' + c.jobType.jobTypeNo + "\">" + c.jobType.name + "</option>"
      });
    }
  }

  //get departments
  result = await MakeRequest("DepartmentList/All");
  if (result != null) {
    var departmentselect = document.getElementById("department");
    if (departmentselect != null) {
      result.forEach(c => {
        departmentselect.innerHTML += "<option value=\"" + c.id + '\x07' + c.department.departmentNo + "\">" + c.department.name + "</option>"
      });
    }
  }

  //get seller
  result = await MakeRequest("EmployeeList/Sellers");
  if (result != null) {
    var sellerselect = document.getElementById("seller");
    if (sellerselect != null) {
      result.forEach(c => {
        sellerselect.innerHTML += "<option value=\"" + c.id + '\x07' + c.employee.employeeNo + "\">" + c.employee.firstName + "</option>"
      });
    }
  }
}

function initializeCustomerSearch() {
  const customerselect = document.getElementById("customerselect");
  if (!customerselect) {
    return;
  }

  if ($(customerselect).data("select2")) {
    return;
  }

  $(customerselect).select2({
    placeholder: {
      id: '-1',
      text: 'Vælg kunde'
    },
    theme: "classic",
    minimumInputLength: 1,
    allowClear: true,
    ajax: {
      delay: 300,
      transport: function (params, success, failure) {
        const payload = buildCustomerSearchPayload(params.data && params.data.q ? params.data.q : "");

        fetch("https://api.arkasoftware.dk/api/CustomerList/Search", {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + token,
          },
          body: JSON.stringify(payload),
        })
          .then(async (response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const results = Array.isArray(data) ? data : [];
            success({
              results: results.map((customerResult) => {
                const customer = customerResult.customer || customerResult;
                const customerNumber = customer.customerNumber || customerResult.customerNumber || "";
                const customerId = customerResult.id ?? customer.id ?? "";

                return {
                  id: customerId + '\x07' + customerNumber,
                  text: customer.name || customerResult.name || "Ukendt kunde"
                };
              })
            });
          })
          .catch((error) => {
            failure(error);
          });
      },
      data: function (params) {
        return {
          q: params.term || ""
        };
      },
      processResults: function (data) {
        return {
          results: data.results || []
        };
      }
    }
  });
}

function buildCustomerSearchPayload(searchTerm) {
  const term = (searchTerm || "").trim();
  const payload = {
    vatNumber: "",
    name: "",
    phoneNumber: "",
    mobil: "",
    email: ""
  };

  if (!term) {
    return payload;
  }

  if (term.includes("@")) {
    payload.email = term;
    return payload;
  }

  if (/^\d+$/.test(term)) {
    payload.vatNumber = term;
    payload.phoneNumber = term;
    payload.mobil = term;
    return payload;
  }

  payload.name = term;
  return payload;
}

async function MakeRequest(path) {
  try {
    if (token != "") {
      const response = await fetch(`https://api.arkasoftware.dk/api/${path}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + token
          },
        });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      //console.log(path, ":", result);

      return result;
    }
  } catch (error) {
    console.log("[path] Error sending data:", error.message);
  }
  return null;
}

var sending = false;
export async function run() {
  if (sending) {
    return;
  }
  sending = true;

  if (token != "") {
    //send workorder
    try {
      const customerVals = safeSplit(document.getElementById("customerselect").value, '\x07');

      if (customerVals[0] == "" && customerVals[1] == "") {
        sending = false;
        return;
      }

      let jsonbody = JSON.stringify({
        customerId: customerVals[0],
        customerNumber: customerVals[1],
        email: "",
        vatNo: "",
        title: document.getElementById("title").value,
        customerRef: document.getElementById("customerref").value,
        generalDescription: document.getElementById("description").value,
        internalDescription: document.getElementById("internaldescription").value,
        solutionDescription: document.getElementById("solutionnote").value,
        freeText1: document.getElementById("textnote1").value,
        freeText2: document.getElementById("textnote2").value,
        freeText3: document.getElementById("textnote3").value,
        freeText4: document.getElementById("textnote4").value,
        status: document.getElementById("status").value,
        startTime: document.getElementById("starttime").value,
        endTime: document.getElementById("stoptime").value,
        deliveryTime: document.getElementById("delivery").value,
        critical: document.getElementById("critical").checked,
        mobilSync: document.getElementById("mobilsync").checked,
        //komoggaasync: document.getElementById("komoggaasync").checked,
        responsible: safeSplit(document.getElementById("responsible").value, '\x07')[0],
        seller: safeSplit(document.getElementById("seller").value, '\x07')[0],
        department: safeSplit(document.getElementById("department").value, '\x07')[0],
        jobType: safeSplit(document.getElementById("type").value, '\x07')[0],
        timeEntryType: safeSplit(document.getElementById("hourtype").value, '\x07')[0],
        docBase64: [
          document.getElementById("attachMail").checked ? mailContent : null
        ],
      });

      //console.log(jsonbody);

      const response = await fetch("https://api.arkasoftware.dk/api/WorkOrder",
        {
          method: "POST",
          body: jsonbody,
          headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + token
          },
        });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      //console.log("Server response:", result);

      sending = false;

      openDialog();
    } catch (error) {
      sending = false;
      console.log("[WorkOrder] Error sending data:", error.message);
    }
  } else {
    sending = false;
    console.log("Ingen forbindelse");
  }
}

function safeSplit(str, separator) {
  if (typeof str !== 'string') {
    return ["", ""]; //Array(length).fill(""); 
  }

  if (str.length === 0) {
    return ["", ""];
  }

  try {
    return str.split(separator);
  } catch (err) {
    console.error('Split failed:', err);
    return ["", ""];
  }
}

function closeDialog() {
  Office.context.ui.closeContainer();
}

function openDialog() {
  document.getElementById("app-body").style.display = "none";
  document.getElementById("inframedialog").style.display = "block";


  /* Office.context.ui.displayDialogAsync(
    "https://arkaaddinstatic-gxhgejgteyhga3bq.z03.azurefd.net/dialog.html",
    {
      height: 8,
      width: 10,
      displayInIframe: true
    },
    function (result) {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;

        // Listen for messages from dialog
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
          //console.log("Message from dialog:", arg.message);
          dialog.close();
          Office.context.ui.closeContainer();
        });
      } else {
        console.error(result.error.message);
      }
    }
  ); */
}

function readCurrentMail() {
  const item = Office.context.mailbox.item;

  if (!Office.context.requirements.isSetSupported("Mailbox", "1.14")) {
    console.warn("Getting the item as an EML file requires Mailbox 1.14.");
    return;
  }

  item.getAsFileAsync((result) => {
    if (result.status !== Office.AsyncResultStatus.Succeeded) {
      console.error("Could not get item as EML:", result.error);
      return;
    }
    mailContent = result.value;
  });
}